import { render } from "./Business.vue?vue&type=template&id=c322c046"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"

import "./Business.vue?vue&type=style&index=0&id=c322c046&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__